/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".ms-BasicMessageBarsExample .ms-MessageBar{margin:10px 0}\n"}]);